module.exports = __webpack_public_path__ + "media/student_v2/assets/images/user-ed01c25eb1f64b03c6a90e697e12e495.svg";